export default Object.freeze({
    PENDING: 'Pending',
    AWARDED: 'Awarded',
    NOT_AWARDED: 'NotAwarded',
  });
  